module.exports = __webpack_public_path__ + "img/news.a7088906.svg";